import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
} from 'material-hu';
import useBackListener from 'src/hooks/useBackListener';
import 'src/components/authentication/i18n';

export type SelectIntanceProps = {
  open: boolean;
  onSelect?: (instance) => void;
  onCancel?: () => void;
  instances: any[],
};

export const SelectInstance: FC<SelectIntanceProps> = (props) => {
  const {
    open,
    onSelect = () => null,
    onCancel = () => null,
    instances,
  } = props;

  useBackListener(onCancel, open);

  const { t } = useTranslation(['AUTH', 'GENERAL']);

  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>
        {t('SELECT_A_COMMUNITY')}
      </DialogTitle>
      <DialogContent
        dividers
      >
        <Grid
          container
        >
          {instances.map((instance) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={instance.id}
              sx={{ justifyContent: 'center', display: 'flex', my: 1 }}
            >
              <Button onClick={() => onSelect(instance)}>
                <div>
                  <img
                    src={instance.logo}
                    style={{ height: '80px', width: '200px', objectFit: 'contain' }}
                    alt={instance.name}
                  />
                  <Typography color="textPrimary">
                    {instance.name}
                  </Typography>
                </div>
              </Button>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <Button
        sx={{ my: 1 }}
        onClick={onCancel}
      >
        {t('GENERAL:CANCEL')}
      </Button>
    </Dialog>
  );
};

export default SelectInstance;
